// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pLzg","buttons":"styles_buttons__3-mCZ"};